import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const PageEditPage = lazy(() => import("./PageEditPage"));
const PageNewPage = lazy(() => import("./PageNewPage"));

const pagesRoutes: RouteObject[] = [
  {
    path: "/groups/:groupSlug/administration/pages/new",
    element: (
      <Suspense fallback={<Loading />}>
        <PageNewPage />
      </Suspense>
    ),
  },
  {
    path: "/administration/pages/new",
    element: (
      <Suspense fallback={<Loading />}>
        <PageNewPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/pages/:pageSlug/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <PageEditPage />
      </Suspense>
    ),
  },
  {
    path: "/pages/:pageSlug/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <PageEditPage />
      </Suspense>
    ),
  },
];

export default pagesRoutes;
